export default __webpack_public_path__ + "static/media/truliv-logo.13ba05a3.jpeg";